var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlertAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 102,
  height: 102,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 49.271,
  r: 33.712,
  fill: "#0564AA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M51 28.525v27.23",
  stroke: "#fff",
  strokeWidth: 6,
  strokeLinecap: "round"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 66.992,
  r: 3.458,
  fill: "#fff"
})));
export default SvgAlertAlt;